import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { initialPromos } from "../../data/initialPromos";

const accentStyles = {
  orange: {
    card: "border-orange-100 bg-orange-50/80 hover:border-orange-200 hover:shadow-orange-100/80",
    bar: "bg-orange-600",
    icon: "bg-orange-600 text-white shadow-orange-200",
    badge: "bg-white text-orange-700 ring-orange-200",
    cta: "text-orange-700 group-hover:text-orange-800",
    glow: "bg-orange-400/20",
  },
  emerald: {
    card: "border-emerald-100 bg-emerald-50/80 hover:border-emerald-200 hover:shadow-emerald-100/80",
    bar: "bg-emerald-600",
    icon: "bg-emerald-600 text-white shadow-emerald-200",
    badge: "bg-white text-emerald-700 ring-emerald-200",
    cta: "text-emerald-700 group-hover:text-emerald-800",
    glow: "bg-emerald-400/20",
  },
};

function PromoCard({ promo, index }) {
  const styles = accentStyles[promo.accent] || accentStyles.emerald;
  const Icon = promo.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.08, duration: 0.4 }}
    >
      <Link
        to={promo.href}
        className={`group relative flex overflow-hidden rounded-2xl border shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg ${styles.card}`}
      >
        <div className={`w-1.5 shrink-0 ${styles.bar}`} />
        <div
          className={`pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full blur-2xl ${styles.glow}`}
          aria-hidden="true"
        />
        <div className="relative flex flex-1 gap-4 items-start p-5 sm:p-6">
          <div
            className={`grid h-12 w-12 shrink-0 place-items-center rounded-xl shadow-md ${styles.icon}`}
          >
            <Icon size={22} aria-hidden="true" />
          </div>
          <div className="min-w-0 flex-1">
            <span
              className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide uppercase ring-1 ${styles.badge}`}
            >
              {promo.badge}
            </span>
            <h3 className="mt-2 text-base font-semibold leading-snug text-gray-900 sm:text-lg">
              {promo.title}
            </h3>
            <p className="mt-1 text-sm leading-relaxed text-gray-600">
              {promo.subtitle}
            </p>
            <span
              className={`mt-3 inline-flex items-center gap-1.5 text-sm font-semibold ${styles.cta}`}
            >
              {promo.cta}
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-0.5"
                aria-hidden="true"
              />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}

export default function Features() {
  return (
    <section className="px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {initialPromos.map((promo, index) => (
            <PromoCard key={promo.id} promo={promo} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
